import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  private baseUrl: string = environment.baseApiUrl;

  constructor(
    private http: HttpClient
  ) { }

  public getStatus(): Observable<boolean> {
    //return new Observable<boolean>(subscriber => { subscriber.next(false); subscriber.complete(); });
    return this.http.get<boolean>(`${this.baseUrl}/status`);
  }
}
